// extracted by mini-css-extract-plugin
module.exports = {"table":"SystemProfileTable_table__2Ciqh"};